<script setup lang="ts">
// Pre-launch placeholder — Variant 02 from the canonical design.
// Centered Insiders logo + thin gold divider + bold mono "Coming soon".
// Cream background with two soft gold radial glows (top-left + bottom-right).
const { t } = useI18n();
</script>

<template>
  <div
    class="absolute inset-0 flex flex-col items-center justify-center overflow-hidden"
    style="
      background:
        radial-gradient(circle at 30% 20%, #ffe9c8, transparent 55%),
        radial-gradient(circle at 75% 80%, #ffe0b0, transparent 55%), #faf6ec;
    "
    aria-hidden="true"
  >
    <UILogo
      :link="false"
      :size="36"
      class="opacity-90"
      style="filter: drop-shadow(0 4px 12px rgba(139, 96, 0, 0.12))"
    />
    <div class="mt-3.5 h-px w-7 bg-[#8B6000] opacity-40" />
    <div class="mt-3 font-mono text-[14px] font-bold uppercase tracking-[0.28em] text-[#8B6000]">
      {{ t('listings.upcomingPlaceholder.comingSoon') }}
    </div>
  </div>
</template>
